import { message } from 'antd';

import { call, put, takeEvery, all, fork, select, takeLatest } from 'redux-saga/effects'
import { fetchPatientVisitsAPI, getVisits, addUpdateVisitAPI, deletePatientExaminationAPI, uploadVisitDocumentAPI, deleteVisitDocumentAPI, createHL7MessageAPI, fetchVisitInvoicesAPI, fetchInvoiceReceiptsAPI, fetchVisitAuditInfoAPI, fetchAppointmentNotesAPI } from '../../../services/appointments-patient-visits-service';
import { ADD_NEW_PATIENT_ERROR } from '../../actions/receptionist/patientsAction';
import {
    FETCH_PATIENT_VISITS, FETCH_PATIENT_VISITS_START, FETCH_PATIENT_VISITS_ERROR, FETCH_PATIENT_VISITS_SUCCESS,
    ADD_UPDATE_VISIT, ADD_UPDATE_VISIT_SUCCESS, ADD_UPDATE_VISIT_START,
    FETCH_VISIT_AUDIT, FETCH_VISIT_AUDIT_START, FETCH_VISIT_AUDIT_SUCCESS, FETCH_VISIT_AUDIT_ERROR,
    DELETE_PATIENT_EXAMINATION, DELETE_PATIENT_EXAMINATION_ERROR, DELETE_PATIENT_EXAMINATION_SUCCESS, UPLOAD_VISIT_DOCUMENT, UPLOAD_VISIT_DOCUMENT_SUCCESS, UPLOAD_VISIT_DOCUMENT_ERROR, DELETE_VISIT_DOCUMENT, DELETE_VISIT_DOCUMENT_SUCCESS, DELETE_VISIT_DOCUMENT_ERROR,
    CREATE_HL7_MESSAGE, CREATE_HL7_MESSAGE_SUCCESS, CREATE_HL7_MESSAGE_ERROR, FETCH_VISIT_INVOICES, FETCH_VISIT_INVOICES_SUCCESS, FETCH_INVOICE_RECEIPTS, FETCH_INVOICE_RECEIPTS_SUCCESS, FETCH_INVOICE_RECEIPTS_ERROR,
    FETCH_APPOINTMENT_NOTES_SUCCESS,
    FETCH_APPOINTMENT_NOTES_ERROR,
    FETCH_APPOINTMENT_NOTES,
    DELETE_QUICK_CODES_EXAMINATION,
    DELETE_QUICK_CODES_EXAMINATION_SUCCESS,
    DELETE_QUICK_CODES_EXAMINATION_ERROR
} from '../../actions/receptionist/visitsAction';


function* fetchVisits({ payload }) {


    try {

        yield put({ type: FETCH_PATIENT_VISITS_START })
        const response = yield call(fetchPatientVisitsAPI, payload.patientId);

        if (response.success) {
            yield put({ type: FETCH_PATIENT_VISITS_SUCCESS, visits: [...response.visits.visits] })

        } else {
            yield put({ type: FETCH_PATIENT_VISITS_ERROR, error: response.error })
            message.error('Failed to fetch visits!');
        }
    }
    catch (error) {
        yield put({ type: FETCH_PATIENT_VISITS_ERROR, error })
        message.error('Failed to fetch visits!');
    }
}

function* addUpdateVisit({ payload }) {

    try {
        yield put({ type: ADD_UPDATE_VISIT_START })
        const response = yield call(addUpdateVisitAPI, payload.visit);


        if (response.success) {
            yield put({ type: ADD_UPDATE_VISIT_SUCCESS, visit: response.visit })
            if (payload.visit.visitId === 0) {
                message.success('Created  visit successfully!');
            } else {
                message.success('Updated  visit successfully!');
            }


        } else {
            yield put({ type: ADD_NEW_PATIENT_ERROR, error: response.error })

            message.error('Failed to update visits!');
        }

    } catch (error) {
        message.error('Failed to update visit!');
        yield put({ type: ADD_NEW_PATIENT_ERROR, error: error })


    }
}
function* deletePatientExamination({ payload }) {
    try {
        const response = yield call(deletePatientExaminationAPI, payload.examinationId);


        if (response.success) {
            yield put({ type: DELETE_PATIENT_EXAMINATION_SUCCESS, visitData: { visitId: payload.visitId, examinationId: payload.examinationId } })
            message.success('Deleted examination successfully!');

        } else {
            yield put({ type: DELETE_PATIENT_EXAMINATION_ERROR, error: response.error })
            message.error('Failed to delete examination!');
        }
    } catch (error) {
        message.error('Failed to delete examination!');
        yield put({ type: DELETE_PATIENT_EXAMINATION_ERROR, error: error })

    }
}

function* deleteQuickCodeExamination({ payload }) {
    try {
        const response = yield call(deletePatientExaminationAPI, payload.examinationId);


        if (response.success) {
            yield put({ type: DELETE_QUICK_CODES_EXAMINATION_SUCCESS, visitData: { visitId: payload.visitId, examinationId: payload.examinationId } })
            message.success('Deleted examination successfully!');

        } else {
            yield put({ type: DELETE_QUICK_CODES_EXAMINATION_ERROR, error: response.error })
            message.error('Failed to delete examination!');
        }
    } catch (error) {
        message.error('Failed to delete examination!');
        yield put({ type: DELETE_QUICK_CODES_EXAMINATION_ERROR, error: error })

    }
}
function* uploadVisitDocument({ payload }) {

    try {
        // yield put({ type: UPLO })
        const response = yield call(uploadVisitDocumentAPI, payload.document);
        if (response.success) {
            yield put({ type: UPLOAD_VISIT_DOCUMENT_SUCCESS, visit: response.data[0] })
            message.success('Uploaded visit document successfully!');

        } else {
            yield put({ type: UPLOAD_VISIT_DOCUMENT_ERROR, error: response.error })
            message.error('Failed to upload visit document!');
        }

    } catch (error) {
        message.error('Failed to upload visit document!');
        yield put({ type: UPLOAD_VISIT_DOCUMENT_ERROR, error: error })
    }
}

function* deleteVisitDocument({ payload }) {
    try {

        const response = yield call(deleteVisitDocumentAPI, payload.documentId, payload.visitNo);

        if (response.success) {
            payload.resolve({ success: true })
            yield put({ type: DELETE_VISIT_DOCUMENT_SUCCESS, visitRequest: { 'fileName': payload.fileName, 'visitNo': payload.visitNo } })
            message.success('Visit document deleted successfully!');

        } else {
            payload.resolve({ success: false })
            yield put({ type: DELETE_VISIT_DOCUMENT_ERROR, error: response.error })
            message.error('Failed to delete visit document!');
        }

    } catch (error) {
        console.log('error in saga', error)
        payload.resolve({ success: false })
        message.error('Failed to delete visit document!');

    }
}

function* createHL7Message({ payload }) {
    try {

        const response = yield call(createHL7MessageAPI, payload.visit.visitId);

        if (response.success) {
            yield put({ type: CREATE_HL7_MESSAGE_SUCCESS, visit: { 'visit': payload.visit, 'hl7Message': response.data } })
            message.success('Created HL7 message successfully!');

        } else {
            yield put({ type: CREATE_HL7_MESSAGE_ERROR, error: response.error })
        }

    } catch (error) {
        message.error('Failed to delete visit document!');
    }
}

function* fetchVisitInvoices({ payload }) {
    try {
        const response = yield call(fetchVisitInvoicesAPI, payload);
        if (response.success) {
            yield put({ type: FETCH_VISIT_INVOICES_SUCCESS, invoices: response.invoices });
            if (response.invoices.length > 0) {
                const result = yield call(fetchInvoiceReceiptsAPI, response.invoices[0]['invoiceId']);
                if (result.success) {
                    yield put({ type: FETCH_INVOICE_RECEIPTS_SUCCESS, receipts: result.receipts })
                }
            }


        } else {
            message.error('Failed to fetch invoice!');
        }

    } catch (error) {
        message.error(error);
    }
}

function* fetchVisitAuditInfo({ payload }) {
    console.log(payload)
    try {
        const response = yield call(fetchVisitAuditInfoAPI, payload);
        if (response.success) {
            yield put({ type: FETCH_VISIT_AUDIT_SUCCESS, auditInfo: response.auditInfo });
        } else {
            message.error('Failed to fetch visit audit info!');
            yield put({ type: FETCH_VISIT_AUDIT_ERROR, auditInfo: [] })
        }

    } catch (error) {
        message.error(error);
    }
}

function* fetchAppointmentNotes({payload}) {
    try {
        console.log('payload', payload)
        const response = yield call (fetchAppointmentNotesAPI, payload);
        if(response.success){
            yield put ({ type: FETCH_APPOINTMENT_NOTES_SUCCESS, payload: {appointmentNotes: response.appointmentNotes, appointmentId:payload} })
        } else {
            message.error('Failed to fetch appointment notes!');
            yield put({ type: FETCH_APPOINTMENT_NOTES_ERROR, auditInfo: [] })
        }
    } catch (error) {
        message.error(error);
    }
}

export function* fetchInvoiceReceipts({ payload }) {
    try {
        const response = yield call(fetchInvoiceReceiptsAPI, payload);
        if (response.success) {
            yield put({ type: FETCH_INVOICE_RECEIPTS_SUCCESS, receipts: response.receipts })
        } else {
            message.error('Failed to fetch invoice receipts!');
            yield put({ type: FETCH_INVOICE_RECEIPTS_ERROR, receipts: [] })

        }

    } catch (error) {
        message.error(error);
    }
}

function* visitsWatcher() {
    yield takeLatest(FETCH_PATIENT_VISITS, fetchVisits)
    yield takeLatest(ADD_UPDATE_VISIT, addUpdateVisit)
    yield takeLatest(DELETE_PATIENT_EXAMINATION, deletePatientExamination)
    yield takeLatest(DELETE_QUICK_CODES_EXAMINATION, deleteQuickCodeExamination)
    yield takeLatest(UPLOAD_VISIT_DOCUMENT, uploadVisitDocument)
    yield takeLatest(DELETE_VISIT_DOCUMENT, deleteVisitDocument)
    yield takeLatest(CREATE_HL7_MESSAGE, createHL7Message)
    yield takeLatest(FETCH_VISIT_INVOICES, fetchVisitInvoices)
    yield takeLatest(FETCH_INVOICE_RECEIPTS, fetchInvoiceReceipts)
    yield takeLatest(FETCH_VISIT_AUDIT, fetchVisitAuditInfo)
    yield takeLatest(FETCH_APPOINTMENT_NOTES,fetchAppointmentNotes)
}


export default function* rootSaga() {
    yield all([visitsWatcher(),])
}